// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bgp_a bht_un bht_cw bht_a","MenuItem__Btn":"bgp_b bht_z"};